/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Fc_Wins_1Inputs */

const en_fc_vs_fc_wins_1 = /** @type {(inputs: Fc_Vs_Fc_Wins_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free forever. No subscription that adds up to hundreds of dollars a year.`)
};

/**
* | output |
* | --- |
* | "Free forever. No subscription that adds up to hundreds of dollars a year." |
*
* @param {Fc_Vs_Fc_Wins_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_fc_wins_1 = /** @type {((inputs?: Fc_Vs_Fc_Wins_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Fc_Wins_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_fc_wins_1(inputs)
});
export { fc_vs_fc_wins_1 as "fc.vs.fc_wins.1" }